import type { Session } from "@stytch/vanilla-js";

export function isFullyAuthedSession(
  session: Session | null | undefined,
): boolean {
  return (
    Boolean(session?.session_id) &&
    (session?.authentication_factors.length ?? 0) >= 2
  );
}
